import OfferItemV2 from '../OfferItemV2';

import './OffersListV2.scss';

const OffersListV2 = ({ offersList, isDashBoard, style }) => (
  <div className="OffersList" style={{ ...style }}>
    {offersList.map((offerItem) => (
      <OfferItemV2
        key={`offer-${offerItem.offerId}`}
        offerItem={offerItem}
        isDashBoard={isDashBoard}
      />
    ))}
  </div>
);

export default OffersListV2;
